import { AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents, ModelEventsList } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import { GameModel } from "../../Models/GameModel";
import { UILivesController } from "./UIGasController";
import { UIScoreController } from "./UIScoreController";
import { UISpeedController } from "./UISpeedController";
import { Container, filters, Rectangle, Sprite } from 'pixi.js';
import { SinkaTweener } from '../../Utils/Tweener';
import { ButtonController } from '../../Common/ButtonController';
import { UIEvents } from '../../Constants/Events';
import { SpineContainer } from '../Common/SpineContainer';

export interface IUIOptions {}

export class UIController extends AnimationBaseController {
    $model: GameModel;
    tweener: SinkaTweener;
    spine: SpineContainer;
    constructor(
        @Inject private options: IUIOptions,
        @Inject private modelEvents: ModelEvents
    ) {
        super('UIController');
    }

    getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.LEVEL_UI_JSON,
            libraryName: 'ui',
            childControllers: {
                lives: {
                    instanceName: 'lives',
                    controller: UILivesController,
                    model: this.$model,
                },
                coins: {
                    instanceName: 'ui_score',
                    controller: UIScoreController,
                    model: this.$model,
                },
                speed: {
                    instanceName: 'main',
                    controller: UISpeedController,
                    model: this.$model,
                },
                shadow: {
                    instanceName: 'shadow',
                    controller: UISpeedController,
                    model: this.$model,
                },
                segments: {
                    instanceName: 'ui_segments',
                    controller: UISpeedController,
                    model: this.$model,
                },
                btn_settings: {
                    instanceName: 'btn_settings',
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.modelEvents.dispatch(
                                this.$model,
                                UIEvents.showSettings,
                                true
                            );
                        },
                    },
                },
            },
            modelWatch: {
                pause: (pause: boolean) => {
                    this.visible = !pause;
                },
            },
        };
    }

    onInitialize() {
        const blur = new filters.BlurFilter();
        blur.passes = 1;
        blur.resolution = 0.25;
        const shadow = this.getDisplayObjectByQuery('shadow')[0] as Container;
        shadow.filters = [blur];

        this.getDisplayObjectByQuery('btn_settings')[0].hitArea = new Rectangle(
            -100,
            -100,
            200,
            200
        );
        this.visible = !this.$model.pause;
    }

    onResize(width: number, height: number, scale: number) {
        if (width / height > 1.1)
            this.scaleX = this.scaleY = height / scale / 1080;
        else this.scaleX = this.scaleY = width / scale / 1080;

        this.y = -height / scale / 2; //+ height / 1792 * 130;
    }
}
